export const buddyCheckboxQuestion_1 = [
  {
    label: "My buddy made me feel welcome on my first day at the office.",
    name: "welcomeOnFirstDay",
    options: ["Strongly Agree", "Agree", "Disagree", "Strongly Disagree"],
  },
  {
    label:
      "My buddy helped me gel with the team members and motivated me to participate in company-related events.",
    name: "helpedGelWithTeam",
    options: ["Strongly Agree", "Agree", "Disagree", "Strongly Disagree"],
  },
  {
    label: "My buddy has helped resolve all my concerns in time.",
    name: "buddyResolvedConcerns",
    options: ["Strongly Agree", "Agree", "Disagree", "Strongly Disagree"],
  },
  {
    label: "I am satisfied with the support provided by my Buddy.",
    name: "satisfiedWithBuddy",
    options: ["Strongly Agree", "Agree", "Disagree", "Strongly Disagree"],
  },
];

export const tableRatingOptions = [
  "Excellent",
  "Very Good",
  "Fair",
  "Poor",
  "Very Poor",
];

export const buddyTableRatingRows = [
  {
    label: "Buddy's knowledge and ability to answer questions",
    name: "knowledgeRating",
  },
  {
    label: "Buddy's approachability and friendliness",
    name: "approachabilityRating",
  },
  {
    label: "Buddy's availability and responsiveness",
    name: "availabilityRating",
  },
];

export const textAreaQuestions = [
  {
    label: "What did you find most helpful about your Buddy's support?",
    name: "mostHelpful",
    rows: 3,
  },
  {
    label: "What could your Buddy have done better to support you?",
    name: "couldDoBetter",
    rows: 3,
  },
];
